<div>
  <section class="fixed-header mat-elevation-z8" tabindex="0">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
      [id]="tourGuideIds.adminContent.tools.toolsTable.id">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container *ngIf="column === 'refresh'">
            <div class="icon-container" (click)="refreshViewTool()">
              <div class="refresh" [id]="tourGuideIds.adminContent.tools.refresh.id">
                <mat-icon [matTooltip]="refreshIcon">refresh</mat-icon>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="column !== 'refresh'">
            {{columnHeaders[column]}}
          </ng-container>
        </th>

        <td mat-cell *matCellDef="let element" [ngClass]="{
            'total': column === 'total',
            'availCnt': column === 'availCnt',
            'inUseCnt': column === 'inUseCnt',
            'minCnt': column === 'minCnt',
            'toolNm': column === 'toolNm'}">

          <ng-container *ngIf="column !== 'action' && column!=='active'">
            <ng-container *ngIf="column === 'toolNm'">
              <span [matTooltip]="element[column]" class="ellipses">{{element[column]}}</span>
            </ng-container>
            <ng-container *ngIf="column !== 'toolNm'">
              {{getFormattedValue(column, element[column])}}
            </ng-container>
          </ng-container>

          <mat-slide-toggle *ngIf="column === 'active'" [disabled]=true [checked]="element.active"></mat-slide-toggle>

          <ng-container *ngIf="column === 'action'">
            <div class="actionContainer">
              <div class="icon-container">
                <mat-icon class="edit-icon cursor"
                  [ngClass]="{ 'disabled disabled-cursor': !tourGuideService.isStartTour && !authService.permissions['edit-tool'] }"
                  [id]="tourGuideIds.adminContent.tools.editBtn.id"
                  matTooltip="{{!authService.permissions['edit-tool'] ? cf.messages.permissionMsg: editIcon}}"
                  (click)="editToolList(element)">edit</mat-icon>
              </div>

              <div class="icon-container">
                <mat-icon class="delete-icon cursor" [id]="tourGuideIds.adminContent.tools.deleteBtn.id"
                  (click)="!element.active ? onDelete(element) : null"
                  [ngClass]="{ 'disabled disabled-cursor': !this.tourGuideService.isStartTour && (element.active || !this.authService.permissions['delete-tool']) }"
                  matTooltip="{{!authService.permissions['delete-tool'] ? cf.messages.permissionMsg: element.active ? activeTool : deleteIcon}}">delete</mat-icon>
              </div>
            </div>
          </ng-container>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan=12>
          <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="center center" class="emptyData">
            {{getNoData}}
          </div>
        </td>
      </tr>
    </table>
  </section>
  <mat-paginator class="paginator" [pageSize]="10" [pageSizeOptions]="constantsService.pageSizeOptions">
  </mat-paginator>
</div>